import React from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Tab,
  Tabs,
  IconButton,
  Avatar,
  Typography,
  Switch,
  ListItemIcon,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Socket, io } from "socket.io-client";
import Callers from "../callers/Callers";
import History from "../history/History";
import RegisterUsers from "../register-users/RegisterUsers";
import PhoneBook from "../phone-book/PhoneBook";
import RegisterUserWithLabel from "../register-user-label/RegisterUserLabel";
import { GlobalStateContext } from "../../context/GlobalStateContext";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface FormInput {
  name: string;
  city?: string;
  phone: string;
  gender: string;
  info: string | undefined;
}

interface ContextForms {
  form1: FormInput;
  form2: FormInput;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Home = () => {
  const { user } = useContext(GlobalStateContext);
  const [value, setValue] = useState(() => {
    return Number(localStorage.getItem("selectedTab")) || 0;
  });
  const [calls, setCalls] = useState([]);
  const [lastMessageTime, setLastMessageTime] = useState(0);
  const methods = useForm<ContextForms>();
  const methods2 = useForm<ContextForms>();
  const methods3 = useForm<ContextForms>();
  const methods4 = useForm<ContextForms>();
  const methods5 = useForm<ContextForms>();
  const methods6 = useForm<ContextForms>();
  const methods7 = useForm<ContextForms>();
  const methods8 = useForm<ContextForms>();
  const methods9 = useForm<ContextForms>();
  const methods10 = useForm<ContextForms>();
  const methods11 = useForm<ContextForms>();
  const methods12 = useForm<ContextForms>();
  const methods13 = useForm<ContextForms>();
  const methods14 = useForm<ContextForms>();
  const methods15 = useForm<ContextForms>();
  const methods80 = useForm<ContextForms>();
  const methods81 = useForm<ContextForms>();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    localStorage.setItem("selectedTab", String(newValue));
    setValue(newValue);
  };

  useEffect(() => {
    const socket: Socket<any> = io("https://phone.ticketin.net");

    let eventTimer: NodeJS.Timeout | null;

    socket.on("event", (data: any) => {
      setCalls(data);
      setLastMessageTime(Date.now());
      if (eventTimer) {
        clearTimeout(eventTimer);
      }

      eventTimer = setTimeout(() => {
        setCalls([]);
      }, 2000);
    });
    return () => {
      if (eventTimer) {
        clearTimeout(eventTimer);
      }
      socket.disconnect();
    };
  }, []);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const [theme, setTheme] = useState<string>(() => {
    return localStorage.getItem("theme") || "light";
  });

  React.useEffect(() => {
    localStorage.setItem("theme", theme);
    try {
      document.documentElement.setAttribute("data-theme", theme);
    } catch (e) {}
  }, [theme]);

  const muiTheme = createTheme({
    palette: {
      mode: theme === "dark" ? "dark" : "light",
      primary: {
        main: theme === "dark" ? "#4f46e5" : "#3f51b5",
      },
      background: {
        default: theme === "dark" ? "#0f172a" : "#ffffff",
        paper: theme === "dark" ? "#1e293b" : "#ffffff",
      },
      text: {
        primary: theme === "dark" ? "#f8fafc" : "#1e293b",
        secondary: theme === "dark" ? "#94a3b8" : "#64748b",
      },
      divider: theme === "dark" ? "#334155" : "#e2e8f0",
    },
    components: {
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: theme === "dark" ? "#1e293b" : "#ffffff",
            border: `1px solid ${theme === "dark" ? "#334155" : "#e2e8f0"}`,
            boxShadow:
              theme === "dark"
                ? "0px 4px 20px rgba(0, 0, 0, 0.5)"
                : "0px 2px 8px rgba(0,0,0,0.15)",
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: theme === "dark" ? "#f8fafc" : "#1e293b",
            "&:hover": {
              backgroundColor: theme === "dark" ? "#334155" : "#f1f5f9",
            },
            "&.Mui-disabled": {
              color: theme === "dark" ? "#94a3b8" : "#64748b",
              opacity: 1,
            },
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: theme === "dark" ? "#334155" : "#e2e8f0",
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            color: theme === "dark" ? "#64748b" : "#94a3b8",
            "&.Mui-checked": {
              color: theme === "dark" ? "#4f46e5" : "#3f51b5",
            },
          },
          track: {
            backgroundColor: theme === "dark" ? "#475569" : "#cbd5e1",
          },
        },
      },
    },
  });

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => setAnchorEl(null);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  return (
    <ThemeProvider theme={muiTheme}>
      <div
        style={{
          backgroundColor: "var(--bg-page)",
          color: "var(--text-primary)",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: theme === "dark" ? "#334155" : "#e2e8f0",
            position: "relative",
            backgroundColor: "var(--card-bg)",
            boxShadow:
              theme === "dark"
                ? "0 1px 3px 0 rgba(0, 0, 0, 0.3)"
                : "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
          }}
        >
          <IconButton
            onClick={handleOpenMenu}
            sx={{
              position: "absolute",
              right: "20px",
              top: "8px",
              zIndex: 99,
              "&:hover": {
                backgroundColor:
                  theme === "dark"
                    ? "rgba(255, 255, 255, 0.05)"
                    : "rgba(0, 0, 0, 0.05)",
              },
            }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar
              sx={{
                bgcolor: theme === "dark" ? "#4f46e5" : "#3f51b5",
                color: "#ffffff",
                width: 40,
                height: 40,
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              {user?.username?.charAt(0).toUpperCase() || "A"}
            </Avatar>
          </IconButton>

          <Menu
            id="account-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            disablePortal
            slotProps={{
              paper: {
                style: {
                  color: "#0b1220",
                  borderRadius: "8px",
                  minWidth: "220px",
                  marginTop: "8px",
                },
              },
            }}
          >
            <MenuItem
              disabled
              sx={{
                color: `#0b1220 !important`,
              }}
            >
              <ListItemIcon>
                <AccountCircleIcon
                  fontSize="large"
                  style={{ color: theme === "dark" ? "#e6eef9" : "#0b1220" }}
                />
              </ListItemIcon>
              <Box>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: 600,
                    color: "#0b1220",
                  }}
                >
                  {user?.username}
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    color: theme === "dark" ? "#000000ff" : "#6b7280",
                  }}
                >
                  {user?.email}
                </Typography>
              </Box>
            </MenuItem>

            <Divider
              style={{
                borderColor: theme === "dark" ? "#163482" : "#dee6fa",
                margin: "8px 0",
              }}
            />

            <MenuItem
              onClick={(e) => e.stopPropagation()}
              sx={{
                color: `#000000`,
                backgroundColor: "transparent !important",
              }}
            >
              <ListItemIcon>
                {theme === "dark" ? (
                  <Brightness4Icon
                    fontSize="small"
                    style={{ color: "#0b1220" }}
                  />
                ) : (
                  <WbSunnyIcon fontSize="small" style={{ color: "#0b1220" }} />
                )}
              </ListItemIcon>
              <h5 style={{ color: "#0b1220" }}>تغيير السمة</h5>
              <Switch
                checked={theme === "dark"}
                onChange={toggleTheme}
                sx={{
                  ml: "auto",
                  "& .MuiSwitch-switchBase": {
                    color: theme === "dark" ? "#9aa6bc" : "#6b7280",
                    "&.Mui-checked": {
                      color: "#000000",
                    },
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: `${
                      theme === "dark" ? "#163482" : "#dee6fa"
                    } !important`,
                  },
                }}
                size="small"
              />
            </MenuItem>

            <MenuItem
              onClick={logout}
              sx={{
                color: "#ef4444 !important",
                backgroundColor: "transparent !important",
              }}
            >
              <ListItemIcon>
                <LogoutIcon fontSize="small" style={{ color: "#ef4444" }} />
              </ListItemIcon>
              <h5 style={{ color: "#ef4444" }}>تسجيل خروج</h5>
            </MenuItem>
          </Menu>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              ".MuiTabs-indicator": { display: "none" },
              ".MuiTabs-flexContainer": {
                height: "70px",
                px: 2,
              },
              ".MuiTab-root": {
                color: "var(--text-primary)",
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 500,
                minHeight: 54,
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor:
                    theme === "dark"
                      ? "rgba(255, 255, 255, 0.05)"
                      : "rgba(0, 0, 0, 0.05)",
                  borderRadius: "8px",
                },
              },
              ".MuiTab-root.Mui-selected": {
                backgroundColor: theme === "dark" ? "#4f46e5" : "#3f51b5",
                color: "#ffffff",
                borderRadius: "8px",
                margin: "8px 4px",
                boxShadow:
                  theme === "dark"
                    ? "0 2px 8px rgba(79, 70, 229, 0.3)"
                    : "0 2px 8px rgba(63, 81, 181, 0.3)",
              },
            }}
          >
            <Tab label="المتصلين" {...a11yProps(0)} />
            <Tab label="سجل المكالمات" {...a11yProps(1)} />
            <Tab label="تسجيل المتصلين" {...a11yProps(2)} />
            <Tab label="ارقام الهواتف" {...a11yProps(3)} />
            <Tab label="اضافة مستخدم مع ليبل" {...a11yProps(4)} />
          </Tabs>
        </Box>

        <Box
          sx={{
            backgroundColor: "var(--bg-page)",
            minHeight: "calc(100vh - 70px)",
          }}
        >
          <CustomTabPanel value={value} index={0}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Callers
                  methods={methods}
                  methods2={methods2}
                  methods3={methods3}
                  methods4={methods4}
                  methods5={methods5}
                  methods6={methods6}
                  methods7={methods7}
                  methods8={methods8}
                  methods9={methods9}
                  methods10={methods10}
                  methods11={methods11}
                  methods12={methods12}
                  methods13={methods13}
                  methods14={methods14}
                  methods15={methods15}
                  methods80={methods80}
                  methods81={methods81}
                  calls={calls}
                />
              </Grid>
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <History />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <RegisterUsers />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <PhoneBook />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <RegisterUserWithLabel />
          </CustomTabPanel>
        </Box>
      </div>
    </ThemeProvider>
  );
};

export default Home;
